import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BUTTON, COMMON_TEXT, DpadKeyCode, DpadZoneType } from '@core/constants';
import { DpadZoneState } from '@core/models/models';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { Subscription } from 'rxjs';

interface OptionItem {
  name: string;
  value: any;
}

@Component({
  selector: 'caremoni-tv-select',
  templateUrl: './select-box-tv.component.html',
  styleUrls: ['./select-box-tv.component.scss']
})
export class SelectBoxTvComponent implements OnInit, OnDestroy, AfterViewChecked  {
  @Input() options: any[] = [];
  @Input() selectedValue: any;
  @Output() valueChange = new EventEmitter<any[]>();
  @ViewChild('dialogSingle') dialogSingle!: ElementRef;

  @Input() xdpad?: number = -1;
  @Input() ydpad?: number = -1;
  @Input() dpad?: number = -1;
  @Input() tabdpad?: number = -1;
  @Input() xtabdpad?: number = -1;
  @Input() ytabdpad?: number = -1;
  @Input() scaledpad?: number = -1;

  @Input() id?: string;
  @Input() disabled = false;
  @Input() isReset = false;
  @Input() placeholder = '';

  dialogVisible = false;
  afterViewInitDialog = false;
  currentZone: number = DpadZoneType.TV_POPUP_SELECT;
  subscription: Subscription = new Subscription();
  displaySelected:string = "";
  BUTTON = BUTTON;
  COMMON_TEXT = COMMON_TEXT;
  private normalizedOptions: OptionItem[] = [];

  constructor(
      private dpadControlService: DpadControlService,
      private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.dpadSbr();
    this.normalizeOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['options']) {
      this.normalizeOptions();
    }
  }

  private normalizeOptions(): void {
    this.normalizedOptions = (this.options || []).map((opt: any) => {
      if (opt && typeof opt === 'object' && 'value' in opt && 'name' in opt) {
        return opt;
      }
      return { name: String(opt), value: opt };
    });
  }

  get viewOptions(): OptionItem[] {
    if(this.normalizedOptions.length === 1 && this.normalizedOptions[0].name.trim() === '') return [];
    return this.normalizedOptions;
  }

  get selectedItemName(): string {
    return this.viewOptions.find(x => String(x.value) === String(this.selectedValue))?.name || '';
  }

  async openDialog() {
    if (this.disabled) return;
    this.dialogVisible = true;
    await this.dpadControlService.initSelectPopup();
  }

  closeDialog() {
    this.dialogVisible = false;
    this.afterViewInitDialog = false;
    let dZone = {
      dType: this.dpad || DpadZoneType.SCREEN,
      dXMin: DpadZoneType.DEFAULT,
      dXMax: DpadZoneType.TV_USER_SETTINGS_MID,
      dYMin: DpadZoneType.DEFAULT,
      dYMax: DpadZoneType.TV_LAYOUT
    }
    this.dpadControlService.goToZone(this.dpad, this.xdpad, this.ydpad, dZone);
  }

  onSelectValue(val: any) {
    this.selectedValue = val.toString();
    this.onOk();
  }

  onOk() {
    this.valueChange.emit(this.selectedValue);
    this.closeDialog();
  }

  onCancel() {
    this.closeDialog();
  }

  dpadSbr(){
    [
      this.dpadControlService.dZoneState$.subscribe((state: DpadZoneState) => {
        if(state.dKey == DpadKeyCode.KEYCODE_BACK && state.dZone == this.currentZone) {
          this.onOk();
        }
      })
    ].forEach(sub => this.subscription.add(sub));
  }

  ngOnDestroy(): void { 
    this.subscription.unsubscribe(); 
  }

  async ngAfterViewChecked(): Promise<void> {
    if(this.dialogVisible && this.dialogSingle && !this.afterViewInitDialog)
    {
      await this.dpadControlService.initSelectPopup();
      this.afterViewInitDialog = true;
    }    
  }
}